export const PRIMARY = "#2ad2a9";
export const BACKGROUNDCOLOR = "rgba(42, 210, 169, 0.1)";
export const SELECTCOLOR = "rgba(42, 210, 169, 0.3)";
export const SOCIALBG = "#ffc991";
export const OTHERBG = "rgb(226, 234, 255)";